@if (seccionActive) {
  <div class="iframe-container">
    <iframe
      id="grafanaIframe"
      [src]="urlGrafana"
      frameborder="0"
      allow="same-origin"
    ></iframe>
  </div>
}


